var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#fff;}\r\n\t.st1{fill:#fff;stroke:#333333;stroke-width:32;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.5,283.28v-54.57l-52.02-9.8c-4.15-18.03-11.27-34.93-20.8-50.16l29.87-43.73l-38.58-38.58l-43.73,29.87    c-15.23-9.53-32.12-16.65-50.16-20.8l-9.8-52.02h-54.57l-9.8,52.02c-18.03,4.15-34.93,11.27-50.16,20.8l-43.73-29.87l-38.58,38.58    l29.87,43.73c-9.53,15.23-16.65,32.12-20.8,50.16l-52.02,9.8v54.57l52.02,9.8c4.15,18.03,11.27,34.93,20.8,50.16l-29.87,43.73    l38.58,38.58l43.73-29.87c15.23,9.53,32.12,16.65,50.16,20.8l9.8,52.02h54.57l9.8-52.02c18.03-4.15,34.93-11.27,50.16-20.8    l43.73,29.87l38.58-38.58l-29.87-43.73c9.53-15.23,16.65-32.12,20.8-50.16L468.5,283.28z M256,347.74    c-50.67,0-91.74-41.07-91.74-91.74s41.07-91.74,91.74-91.74s91.74,41.07,91.74,91.74S306.67,347.74,256,347.74z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.9c5c38aa01acd75f5adb726f57b8b9db.svg";
export { ForwardRef as ReactComponent };